import React, { useState, useEffect } from "react";
import IconDelete from "../../../../assets/icons/trashWhiteIcon.svg";
import { useNavigate } from "react-router-dom";
import AddButton from "../../../fragments/Buttons/AddButton";
import FilterInput from "../../../fragments/Inputs/FilterInput";
import { formatearFecha } from "../../../constructor/umas/Actividades/ActividadesUtils/ActividadesUtils";

const TareasFilter = ({ data, setFilteredData }) => {
  const [inputvalue, setinputValue] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const filteredTests = data.filter((el) => {
      return (
        el?.nombre?.includes(inputvalue) ||
        formatearFecha(el?.fechaCreacion).includes(inputvalue)
      );
    });
    setFilteredData(filteredTests);
  }, [inputvalue]);

  const createNewTarea = () => {
    navigate("/creadorTareas");
  };

  const openPapelera = () => {
    navigate("/papeleraTareas");
  };

  // Mismo encabezado que el Gestor: `FilterInput` y `AddButton` compartidos, y
  // el espaciado lo da el `mx-3` del botón en lugar del padding del contenedor.
  return (
    <div className="flex items-center justify-center">
      <FilterInput
        value={inputvalue}
        onChange={(e) => setinputValue(e.target.value)}
        placeholder={"Buscar..."}
      />
      <AddButton
        text={"Crear tarea"}
        styles="mx-3 inline-block"
        onClick={createNewTarea}
      />
      <button
        className="btn-nimbus flex items-center mr-3"
        onClick={openPapelera}
      >
        <img src={IconDelete} alt="" />
        <div className="ml-2">Papelera</div>
      </button>
    </div>
  );
};

export default TareasFilter;
